export { default } from './EntityFormModalHead';
